import { useMemo } from "react";
import Fuse, { FuseResult, IFuseOptions } from "fuse.js";

export function useFuzzySearch<T>(
  items: Array<T> | undefined,
  searchTerm: string,
  options?: IFuseOptions<T>,
): Array<FuseResult<T>> {
  const fuse = useMemo(
    () => (items ? new Fuse(items, options) : null),
    [items, options],
  );

  return useMemo(
    () => (fuse ? fuse.search(searchTerm) : new Array<FuseResult<T>>()),
    [fuse, items, searchTerm],
  );
}
